import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmModal from "../../../components/ConfirmModal";
import {
  Button,
  Card,
  Col,
  Container,
  FloatingLabel,
  Form,
  Row,
} from "react-bootstrap";
import TableForm2s from "../../../components/TableFormScrb";
import { initializeSetOption } from "../../../utils/InitializeSetDefault";
import InputSearch from "../../../components/InputSearhComponent";
import { formatInputDate, toFormatISO } from "../../../utils/Time";
import { addEditServiceRequest, getServiceRequest } from "../../../commons/ServiceRequest";
import TechDeliverDocService from "../../../services/techdeliverydoc";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { getQueryString } from "../../../utils/Query";
import EmployeesService from "../../../services/employee.service";

export default function EditDeliveryDocuments() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const [data, setData] = useState(state);
  const [showModal, setShowModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [Employee, setEmployee] = useState();
  const [dataModal, setDataModal] = useState();

  const searchInput = [
    {
      name: "date_attended_during",
      label: "วันที่เข้างานระหว่าง",
      classNames: "mb-3",
      size: 3,
      value: "",
      type: "date"
    },
    {
      name: "up_to_date",
      label: "ถึงวันที่",
      classNames: "mb-3",
      size: 3,
      value: "",
      type: "date"
    },
    {
      name: "Sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: "mb-3",
      size: 3,
      disabled: true,
      value: null,
      type: "text"
    },
    {
      name: "Technician_name ",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: "mb-3",
      size: 3,
      disabled: true,
      value: null,
      type: "text"
    },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    setShowModal(true);
  };

  const handleSubmitTCS = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    const body = dataCallback.Array.map(item => ({
      "tech_work_close_id": item.tech_work_close_id,
      "tech_plan_id": item.tech_plan_id,
      "tech_deliver_date": item.Tech_Delivery_Date,
      "depart_st_id": item.Depart_St_Id,
      "tcs_accept_date": item.Accept_Date,
      "tcs_accept_id": item.Employee_Tcs,
    }))

    try {
      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: TechDeliverDocService.createTechDeliverDoc({ array: body }),
        navigated: () => navigate("/service_work/delivery", {
          state: { tab: "TCSCheckDoc" }
        })
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleSubmitBSC = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    const body = dataCallback.Array.map(item => ({
      "tech_work_close_id": item.tech_work_close_id,
      "tech_plan_id": item.tech_plan_id,
      "tech_deliver_date": item.Tech_Delivery_Date,
      "depart_st_id": item.Depart_St_Id,
      "bsc_accept_date": item.Accept_Date,
      "bsc_accept_id": item.Employee_Bsc,
    }))

    try {
      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: TechDeliverDocService.createTechDeliverDoc({ array: body }),
        navigated: () => navigate("/service_work/delivery", {
          state: { tab: "BSCCheckDoc" }
        })
      });
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      readOnly: true,
    },
    {
      name: "Ref_Do_No",
      label: "เลขที่ใบเบิก",
      readOnly: true,
    },
    {
      name: "Bill_Doc_No",
      label: "เลขที่ใบขอเบิก",
      readOnly: true,
    },
    {
      name: "Item_Return_No",
      label: "เลขที่ใบขอคืน",
      readOnly: true,
    },
    {
      name: "Service_Rep_No",
      label: "เลขใบงานบริการ",
      readOnly: true,
    },
    {
      name: "Seq_St_Id",
      label: "สถานะใบสั่งงาน",
      readOnly: true,
      format: (row) => state?.DepartJobs?.find(s => s.Seq_St_Id == row.Seq_St_Id)?.Depart_St_Name,
    },
    state.type == "TCSCheckDoc" ? {
      name: "Tech_Delivery_Date",
      label: "วันที่ช่างนำส่ง",
      type: "date"
    } : {
      name: "TCS_Date",
      label: "วันที่TCSนำส่ง",
      type: "date",
      readOnly: true
    },
    {
      name: "Accept_Date",
      label: "วันที่ตรวจรับ",
      type: "date"
    },
    {
      name: state.type == "TCSCheckDoc" ? "Employee_Tcs" : "Employee_Bsc",
      label: "ผู้ตรวจรับ",
      type: "select",
      minKeywordLength: 1,
      // defaultOption: { label: "Employee_Name" },
      defaultOption: Employee || { label: "Employee_Name" },
      queryService: (query, value) => {

        const q = getQueryString({
          keyword: value, limit: 100, page: 1,
        })
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: EmployeesService.getAllEmployees(q),
          callback: ({ items }) => {
            setEmployee(items)
          }
        })
      },
      options: initializeSetOption({
        key: "Id",
        label: "Employee_Name",
        dataset: Employee
      })
    },
    {
      name: "Depart_St_Id",
      label: "สถานะ",
      type: "select",
      noneAsync: true,
      filterBy: ["Depart_St_Name"],
      width: "200px",
      showTooltip: true,
      options: initializeSetOption({
        key: "Id",
        label: "Depart_St_Name",
        dataset: state?.DepartJobs
      })
    },
  ];

  function getDataTCS(search) {
    const q = {
      page: search?.page || 1, limit: search?.limit || 10,
      start: toFormatISO(search.start),
      end: toFormatISO(search.end)
    }
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechDeliverDocService.getDocDeliverInform(getQueryString(q)),
      callback: (res) => {

        setTableData(
          res.data.map(el => ({
            Seq_No: el.seq_no,
            Bill_Doc_No: el.BillOfReqHd.Bill_Doc_No,
            Ref_Do_No: el.BillOfReqHd.Ref_Do_No,
            Item_Return_No: el.TechWorkClosed.TechItemReturnBill.item_return_no,
            Service_Rep_No: el.TechWorkClosed.service_rep_no,
            Seq_St_Id: el.DepartJob?.Seq_St_Id,
            Tech_Delivery_Date: formatInputDate(el.TechDeliverDoc?.tech_deliver_date, "Local")?.date,
            Accept_Date: formatInputDate(el.TechDeliverDoc?.tcs_accept_date || new Date(), "Local")?.date,
            Employee_Tcs: el.TechDeliverDoc?.EmployeeTcs?.Id,
            Employee_Name: { label: el.TechDeliverDoc?.EmployeeTcs?.Employee_Name },
            Depart_St_Id: el.DepartJob?.Id,
            "tech_work_close_id": el.TechDeliverDoc?.tech_work_close_id,
            "tech_plan_id": el.TechDeliverDoc?.tech_plan_id,
          }))
        )

      }
    });
  }

  function getDataBSC(search) {
    const q = {
      page: search?.page || 1, limit: search?.limit || 10,
      start: toFormatISO(search.start),
      end: toFormatISO(search.end)
    }
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechDeliverDocService.getDocDeliverInform(getQueryString(q)),
      callback: (res) => {
        setTableData(
          res.data.map(el => ({
            Seq_No: el.seq_no,
            Bill_Doc_No: el.BillOfReqHd.Bill_Doc_No,
            Ref_Do_No: el.BillOfReqHd.Ref_Do_No,
            Item_Return_No: el.TechWorkClosed.TechItemReturnBill.item_return_no,
            Service_Rep_No: el.TechWorkClosed.service_rep_no,
            Seq_St_Id: el.DepartJob?.Seq_St_Id,
            TCS_Date: formatInputDate(el.TechDeliverDoc?.tcs_accept_date, "Local")?.date,
            Accept_Date: formatInputDate(el.TechDeliverDoc?.bsc_accept_date || new Date(), "Local")?.date,
            Employee_Bsc: el.TechDeliverDoc?.EmployeeBsc?.Id,
            Employee_Name: { label: el.TechDeliverDoc?.EmployeeBsc?.Employee_Name },
            Depart_St_Id: el.DepartJob?.Id,
            "tech_work_close_id": el.TechDeliverDoc?.tech_work_close_id,
            "tech_plan_id": el.TechDeliverDoc?.tech_plan_id,
          }))
        )

      }
    });
  }

  return (
    <>
      <Helmet>
        <title>
          {data.type === "deliveryDoc"
            ? "ช่างนำส่งเอกสาร"
            : data.type === "TCSCheckDoc"
              ? "TCS - ตรวจสอบเอกสาร"
              : "BSC - ตรวจรับเอกสาร"}
        </title>
        <meta
          name="description"
          content={
            data.type === "deliveryDoc"
              ? "Edit Delivery Doc"
              : data.type === "TCSCheckDoc"
                ? "Edit TCS check documents"
                : "Edit BSC check documents"
          }
        />
      </Helmet>

      <Container fluid className="p-0">
        {data.type == "TCSCheckDoc" &&
          < div className="m-0 p-3 w-100">
            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="mb-4 pt-0 px-0 fs-2 text-center text-dark bg-white border-0">
                รายละเอียดเอกสารที่นำส่ง
              </Card.Header>
              <InputSearch
                inputField={searchInput}
                field={searchInput}
                searchCallback={search => { search ? getDataTCS(search) : setTableData([]) }}
                fieldClassName={{ actionButton: "w-auto py-2", inputRow: "justify-content-center" }}
              />
            </Card>
            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Body className="p-0">
                <Card.Title className="mb-0 fs-2">
                  รายละเอียดข้อมูลการนำส่งเอกสาร
                </Card.Title>
                <Form noValidate className=" " onSubmit={handleSubmit}>
                  <TableForm2s
                    data={tableData}
                    columns={columns}
                    pagination={false}
                    onChangeCallback={(newData) => {
                      setTableData(newData)
                      setDataModal({ Array: newData })
                    }}
                  />
                  <Row className="text-end py-3">
                    <Col>
                      <Button
                        type="submit"
                        variant="success"
                        className="me-2 px-5 py-2 rounded-pill"
                        disabled={!dataModal}
                      >
                        บันทึกข้อมูล
                      </Button>
                      <ConfirmModal
                        show={showModal}
                        data={dataModal}
                        content="edit"
                        onSubmitCallback={handleSubmitTCS}
                      />
                      <Button
                        variant="outline-success"
                        className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                        onClick={() => navigate("/service_work/delivery", {
                          state: { tab: "TCSCheckDoc" }
                        })}
                      >
                        ย้อนกลับ
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>
        }

        {data.type == "BSCCheckDoc" &&
          <div className="m-0 p-3 w-100">
            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="mb-4 pt-0 px-0 fs-2 text-center text-dark bg-white border-0">
                ข้อมูลการนำส่งเอกสาร
              </Card.Header>
              <InputSearch
                inputField={searchInput}
                field={searchInput}
                searchCallback={search => { search ? getDataBSC(search) : setTableData([]) }}
                fieldClassName={{ actionButton: "w-auto py-2", inputRow: "justify-content-center" }}
              />
            </Card>

            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Body className="p-0">
                <Card.Title className="mb-0 fs-2">
                  รายละเอียดข้อมูลการนำส่งเอกสาร
                </Card.Title>
                <Form noValidate className="" onSubmit={handleSubmit}>
                  <TableForm2s
                    data={tableData}
                    columns={columns}
                    pagination={false}
                    onChangeCallback={(newData) => {
                      setTableData(newData)
                      setDataModal({ Array: newData })
                    }}
                  />
                  <Row>

                    <Row className="text-end py-3">
                      <Col>
                        <Button
                          type="submit"
                          variant="success"
                          className="me-2 px-5 py-2 rounded-pill"
                          disabled={!dataModal}
                        >
                          บันทึกข้อมูล
                        </Button>
                        <ConfirmModal
                          show={showModal}
                          data={dataModal}
                          content="edit"
                          onSubmitCallback={handleSubmitBSC}
                        />
                        <Button
                          variant="outline-success"
                          className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                          onClick={() => navigate("/service_work/delivery", {
                            state: { tab: "BSCCheckDoc" }
                          })}
                        >
                          ย้อนกลับ
                        </Button>
                      </Col>
                    </Row>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>
        }
      </Container >
    </>
  );
}
